import React from 'react'
import { Result } from 'antd'
import * as Sentry from '@sentry/react'
import moment from 'moment'
import FrownOutlined from '@ant-design/icons/FrownOutlined'
import { captureException } from '@/utils/track'

import styles from './index.less'

const wrapStyle = {
    width: '70vw',
    marginTop: '10vh',
    marginLeft: '15vw',
}

const ErrorComponent = ({ children, pathname = '', hideFallbackContent, anchor }) => {
    const fallback = props => {
        const { error, componentStack } = props

        const eventId = captureException(
            `环境:${
                window.PROJECT_CONFIG.sentryMode || window.PROJECT_CONFIG.mode
            }应用发生问题，请刷新页面或联系客服。${error.message}`,
            {
                anchor: anchor || 'root layout FallbackComponent',
                extra: {
                    error,
                },
                mustNotify: true,
            },
        )

        // 隐藏内容，只提交
        if (hideFallbackContent) {
            return null
        }

        if (PROJECT_CONFIG.mode === 'prod') {
            return (
                <div className={styles.fallback}>
                    <Result
                        icon={<FrownOutlined />}
                        title={<div>应用发生问题，请刷新后重试或联系客服。</div>}
                        extra={
                            <div>
                                <div className={styles.eventId}>
                                    {moment().format('YYYY-MM-DD HH:mm:ss')} {eventId}
                                </div>
                            </div>
                        }
                    />
                </div>
            )
        }
        return (
            <div style={wrapStyle}>
                <h1>应用发生问题，请火速联系前端</h1>
                <div>
                    <pre> {error.message}</pre>
                </div>
                <div>
                    <pre>{componentStack}</pre>
                </div>
            </div>
        )
    }

    return (
        <Sentry.ErrorBoundary key={pathname} fallback={fallback}>
            {children}
        </Sentry.ErrorBoundary>
    )
}

export default ErrorComponent
